import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

import { Loader } from "components/Loader";
import { Layout } from "components/Layout";
import { SureAlert } from "components/SureAlert";
import { useFetchAssignedTestsByCondition } from "hooks/useQuery/tests/useFetchAssignedTestsByCondition";
import styles from "./PupilsStep.module.scss";

moment.locale("ru");

export const PupilsStep = ({
    loading,
    conditionId,
    classData,
    pupils,
    filteredPupils,
    selectAll,
    selectAllHandler,
    checkboxHandler,
    clickHandler,
}) => {
    const { t } = useTranslation("tests");
    const [isSureAlert, setIsSureAlert] = useState(false);
    const { assignedTests, assignedTestsIsLoading } = useFetchAssignedTestsByCondition(conditionId, classData?._id);

    function onSendClick() {
        setIsSureAlert(true);
    }

    function onCloseClick() {
        setIsSureAlert(false);
    }

    if (loading || !classData || assignedTestsIsLoading) {
        return <Loader />;
    }

    return (
        <Layout>
            <div className="page__content" style={{ paddingBottom: 100 + "px" }}>
                <h3>{t("select_pupils")}</h3>
                <p className="page__desc">
                    {classData.number}
                    {classData.letter}, {t("total")} {classData.pupils.length} {t("pupils")}
                </p>
                <p className={`select-all ${selectAll ? "select-all_active" : null}`} onClick={selectAllHandler}>
                    {t("select_all")}
                </p>
                <div className="list">
                    {filteredPupils.map((pupil) => {
                        const isSent = assignedTests.find(({ pupilId }) => pupilId === pupil._id);
                        const latestDate = isSent
                            ? `Направлено ${moment(isSent.latestDate).format("HH:mm, DD MMM, YYYY")}`
                            : "Тест ещё не назначался";

                        return (
                            <div key={pupil._id} className="list__checkbox">
                                <input
                                    id={pupil._id}
                                    type="checkbox"
                                    name={pupil._id}
                                    checked={pupils.includes(pupil._id)}
                                    onChange={checkboxHandler}
                                    value={pupil._id}
                                />
                                <label htmlFor={pupil._id}>
                                    <div>
                                        <p>
                                            {pupil.surname} {pupil.name}
                                        </p>
                                        <span className={styles.sent}>{latestDate}</span>
                                    </div>
                                </label>
                            </div>
                        );
                    })}
                </div>
                {/* Временно отключена кнопка "Показывать результат ученикам" */}
                {/*<div className="bool-field">*/}
                {/*    <p>{t("show_results_to_pupils")}</p>*/}
                {/*    <div*/}
                {/*        onClick={props.visibleHandler}*/}
                {/*        className={`swipe ${props.isVisible && "swipe_active"}`}*/}
                {/*    />*/}
                {/*</div>*/}
                <div className="send-btn">
                    <button onClick={onSendClick} className="main-btn">
                        {t("send_button")}
                    </button>
                </div>
            </div>

            {isSureAlert && (
                <SureAlert
                    type="createTest"
                    handleClose={onCloseClick}
                    handleSubmit={() => {
                        clickHandler();
                        onCloseClick();
                    }}
                />
            )}
        </Layout>
    );
};
